import React from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
Card.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
export default function Card(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "flex flex-col bg-white p-5 text-black shadow-md dark:bg-blue-800 dark:text-gray-200 sm:rounded-xl md:mb-0 md:p-7",
            className
        ]))
    }, children);
}
